import React from 'react';
import {
  FaDumbbell,
  FaFire,
  FaHeartPulse,
  FaTrophy,
  FaSeedling,
  FaShieldHeart,
  FaUserCheck,
  FaLaptopCode,
  FaWeightHanging
} from 'react-icons/fa6';

export const programsData = [
  {
    id: "strength-training",
    heading: "STRENGTH TRAINING",
    shortTitle: "Build Strength",
    category: "Strength",
    icon: <FaDumbbell className="w-6 h-6" />,
    idealFor: "People who want to become stronger, improve their lifting performance, build a solid foundation and develop confidence with resistance training.",
    explore: "Build real strength through structured resistance training, progressive overload and technique-focused coaching. Every program is designed around your current ability and gradually progresses as you become stronger.",
    weeklyPlan: [
      { day: "Day 1", activity: "Lower Body Strength" },
      { day: "Day 2", activity: "Upper Body Strength" },
      { day: "Day 3", activity: "Rest / Recovery" },
      { day: "Day 4", activity: "Lower Body Strength" },
      { day: "Day 5", activity: "Upper Body Strength" },
      { day: "Day 6–7", activity: "Recovery / Optional activity" }
    ],
    sampleWorkoutTitle: "Sample Workout — Lower Body",
    sampleWorkout: [
      { exercise: "Squat", prescribe: "3–4 sets × 4–6 reps" },
      { exercise: "Romanian Deadlift", prescribe: "3 × 6–8 reps" },
      { exercise: "Leg Press", prescribe: "3 × 8–10 reps" },
      { exercise: "Leg Curl", prescribe: "3 × 8–12 reps" },
      { exercise: "Calf Raise", prescribe: "3 × 10–15 reps" },
      { exercise: "Core Training", prescribe: "2–3 sets" }
    ],
    progression: "Track your exercises, repetitions and loads. Gradually increase training demands when technique and recovery allow."
  },
  {
    id: "muscle-building",
    heading: "MUSCLE BUILDING / HYPERTROPHY",
    shortTitle: "Build Muscle",
    category: "Hypertrophy",
    icon: <FaWeightHanging className="w-6 h-6" />,
    idealFor: "People who want to build muscle, improve body shape and develop a more muscular physique.",
    explore: "Build muscle with a structured hypertrophy program combining effective exercises, appropriate training volume, controlled execution and progressive overload.",
    weeklyPlan: [
      { day: "Day 1", activity: "Chest + Triceps" },
      { day: "Day 2", activity: "Back + Biceps" },
      { day: "Day 3", activity: "Legs" },
      { day: "Day 4", activity: "Rest" },
      { day: "Day 5", activity: "Shoulders + Arms" },
      { day: "Day 6", activity: "Upper Body / Weak Points" },
      { day: "Day 7", activity: "Rest" }
    ],
    sampleWorkoutTitle: "Sample Workout — Chest + Triceps",
    sampleWorkout: [
      { exercise: "Bench Press", prescribe: "3 × 6–8 reps" },
      { exercise: "Incline Dumbbell Press", prescribe: "3 × 8–10 reps" },
      { exercise: "Cable Fly", prescribe: "3 × 10–15 reps" },
      { exercise: "Lateral Raise", prescribe: "3 × 12–15 reps" },
      { exercise: "Triceps Pushdown", prescribe: "3 × 10–15 reps" },
      { exercise: "Overhead Triceps Extension", prescribe: "2–3 × 10–15 reps" }
    ],
    progression: "Improve repetitions, load, execution and overall training performance over time rather than simply adding more exercises."
  },
  {
    id: "fat-loss",
    heading: "FAT LOSS",
    shortTitle: "Fat Loss & Shred",
    category: "Fat Loss",
    icon: <FaFire className="w-6 h-6" />,
    idealFor: "People who want to reduce body fat while maintaining or building muscle and improving overall fitness.",
    explore: "Our fat-loss approach combines resistance training, conditioning, daily activity and practical nutrition guidance to help you create sustainable progress without relying only on cardio.",
    weeklyPlan: [
      { day: "Day 1", activity: "Full Body Resistance" },
      { day: "Day 2", activity: "Conditioning + Core" },
      { day: "Day 3", activity: "Full Body Resistance" },
      { day: "Day 4", activity: "Recovery / Walking" },
      { day: "Day 5", activity: "Full Body Resistance" },
      { day: "Day 6", activity: "Conditioning / Activity" },
      { day: "Day 7", activity: "Rest" }
    ],
    sampleWorkoutTitle: "Sample Workout — Full Body Resistance & Cardio",
    sampleWorkout: [
      { exercise: "Goblet Squat", prescribe: "3 × 10–12 reps" },
      { exercise: "Dumbbell Bench Press", prescribe: "3 × 8–12 reps" },
      { exercise: "Lat Pulldown", prescribe: "3 × 8–12 reps" },
      { exercise: "Romanian Deadlift", prescribe: "3 × 8–10 reps" },
      { exercise: "Cable Row", prescribe: "3 × 10–12 reps" },
      { exercise: "Walking / Bike Intervals", prescribe: "10–15 min" },
      { exercise: "Core Circuit", prescribe: "2–3 sets" }
    ],
    progression: "Progress is evaluated through body measurements, body weight trends, strength, fitness performance and consistency—not just the weighing scale."
  },
  {
    id: "beginner-fitness",
    heading: "BEGINNER FITNESS",
    shortTitle: "Beginner Foundation",
    category: "Beginner",
    icon: <FaSeedling className="w-6 h-6" />,
    idealFor: "Complete beginners, people returning to training and anyone who wants to learn how to use the gym correctly.",
    explore: "Start with the fundamentals. Learn proper exercise technique, build strength, improve mobility and develop the confidence to train independently.",
    weeklyPlan: [
      { day: "Day 1", activity: "Full Body" },
      { day: "Day 2", activity: "Rest" },
      { day: "Day 3", activity: "Full Body" },
      { day: "Day 4", activity: "Rest" },
      { day: "Day 5", activity: "Full Body" },
      { day: "Day 6–7", activity: "Recovery / Activity" }
    ],
    sampleWorkoutTitle: "Sample Workout — Fundamental Full Body",
    sampleWorkout: [
      { exercise: "Leg Press", prescribe: "3 × 10 reps" },
      { exercise: "Chest Press", prescribe: "3 × 10 reps" },
      { exercise: "Lat Pulldown", prescribe: "3 × 10 reps" },
      { exercise: "Seated Row", prescribe: "3 × 10 reps" },
      { exercise: "Dumbbell Shoulder Press", prescribe: "2 × 10 reps" },
      { exercise: "Leg Curl", prescribe: "2 × 12 reps" },
      { exercise: "Plank Hold", prescribe: "2–3 sets" }
    ],
    progression: "First master movement quality. Then gradually increase repetitions, resistance and training complexity."
  },
  {
    id: "endurance-conditioning",
    heading: "ENDURANCE & CONDITIONING",
    shortTitle: "Endurance & Cardio",
    category: "Conditioning",
    icon: <FaHeartPulse className="w-6 h-6" />,
    idealFor: "People who want better stamina, cardiovascular fitness, work capacity and overall conditioning.",
    explore: "Improve your ability to perform, recover and sustain physical effort through a combination of cardiovascular training, resistance training and conditioning.",
    weeklyPlan: [
      { day: "Day 1", activity: "Strength + Conditioning" },
      { day: "Day 2", activity: "Cardio" },
      { day: "Day 3", activity: "Recovery" },
      { day: "Day 4", activity: "Strength + Intervals" },
      { day: "Day 5", activity: "Cardio / Conditioning" },
      { day: "Day 6", activity: "Optional activity" },
      { day: "Day 7", activity: "Rest" }
    ],
    sampleWorkoutTitle: "Sample Conditioning Session",
    sampleWorkout: [
      { exercise: "Rowing / Cycling", prescribe: "Controlled Rounds" },
      { exercise: "Bodyweight Squats", prescribe: "High Tempo" },
      { exercise: "Push-ups", prescribe: "Controlled Execution" },
      { exercise: "Walking Lunges", prescribe: "Continuous Motion" },
      { exercise: "Battle Ropes / Cardio", prescribe: "Work-to-Rest Intervals" }
    ],
    specialNote: "The intensity and work-to-rest ratio should be adjusted according to the individual's fitness level.",
    progression: "Gradually build aerobic capacity, reduce recovery downtime between rounds, and increase overall work output."
  },
  {
    id: "athletic-performance",
    heading: "ATHLETIC PERFORMANCE",
    shortTitle: "Athletic Performance",
    category: "Performance",
    icon: <FaTrophy className="w-6 h-6" />,
    idealFor: "Athletes and active individuals who want to improve strength, power, speed, coordination and conditioning.",
    explore: "Train beyond basic strength. Develop the physical qualities that support athletic performance through structured strength, power, movement and conditioning work.",
    weeklyPlan: [
      { day: "Day 1", activity: "Lower Strength + Power" },
      { day: "Day 2", activity: "Upper Strength" },
      { day: "Day 3", activity: "Conditioning / Recovery" },
      { day: "Day 4", activity: "Lower Strength + Power" },
      { day: "Day 5", activity: "Upper Strength + Conditioning" },
      { day: "Day 6", activity: "Mobility / Recovery" },
      { day: "Day 7", activity: "Rest" }
    ],
    sampleWorkoutTitle: "Sample Workout — Lower Strength + Power",
    sampleWorkout: [
      { exercise: "Box Jump", prescribe: "3 × 3–5 reps" },
      { exercise: "Squat", prescribe: "3 × 4–6 reps" },
      { exercise: "Romanian Deadlift", prescribe: "3 × 6–8 reps" },
      { exercise: "Split Squat", prescribe: "3 × 8 each side" },
      { exercise: "Calf Raise", prescribe: "3 × 10–15 reps" },
      { exercise: "Core / Carry", prescribe: "2–3 sets" }
    ],
    progression: "Focus on explosive power output, movement mechanics, rate of force development and athletic conditioning."
  },
  {
    id: "functional-fitness",
    heading: "FUNCTIONAL FITNESS",
    shortTitle: "Functional Fitness",
    category: "Functional",
    icon: <FaShieldHeart className="w-6 h-6" />,
    idealFor: "People who want to improve everyday movement, strength, balance, coordination, mobility and general physical capability.",
    explore: "Develop a stronger and more capable body through training that combines strength, stability, mobility, coordination and conditioning.",
    weeklyPlan: [
      { day: "Day 1", activity: "Full Body Strength" },
      { day: "Day 2", activity: "Mobility + Conditioning" },
      { day: "Day 3", activity: "Full Body Strength" },
      { day: "Day 4", activity: "Recovery" },
      { day: "Day 5", activity: "Full Body Functional Training" },
      { day: "Day 6", activity: "Light Activity" },
      { day: "Day 7", activity: "Rest" }
    ],
    sampleWorkoutTitle: "Sample Functional Full Body Session",
    sampleWorkout: [
      { exercise: "Kettlebell Deadlift / Swing", prescribe: "3 × 10 reps" },
      { exercise: "Dumbbell Step-ups", prescribe: "3 × 8 each side" },
      { exercise: "Push-ups / Overhead Press", prescribe: "3 × 10 reps" },
      { exercise: "Inverted Rows / Pulldowns", prescribe: "3 × 10 reps" },
      { exercise: "Farmer's Loaded Carry", prescribe: "3 × 30 meters" },
      { exercise: "Core Stability & Mobility", prescribe: "2–3 sets" }
    ],
    progression: "Enhance movement quality, rotational power, joint stability, and daily functional resilience."
  },
  {
    id: "personal-training",
    heading: "PERSONAL TRAINING",
    shortTitle: "Personal Training",
    category: "1-on-1 Coaching",
    icon: <FaUserCheck className="w-6 h-6" />,
    idealFor: "People who want closer coaching, individualized programming, technique correction and greater accountability.",
    explore: "Get a training plan built around you. Your coach guides exercise selection, technique, intensity, progression and training consistency while adapting the program according to your progress.",
    flowTitle: "Personal Training Coaching Flow",
    flowSteps: [
      "Consultation",
      "Assessment",
      "Goal Setting",
      "Program Design",
      "Coaching",
      "Progress Tracking",
      "Program Adjustment"
    ],
    progression: "Receive 1-on-1 direct trainer supervision, real-time posture/technique corrections, and continuously adjusted target loads."
  },
  {
    id: "online-coaching",
    heading: "ONLINE COACHING",
    shortTitle: "Online Coaching",
    category: "Remote",
    icon: <FaLaptopCode className="w-6 h-6" />,
    idealFor: "People who cannot train directly with an IDOL coach but still want structured professional guidance.",
    explore: "Train wherever you are with a structured program designed around your goal, available equipment, schedule and experience.",
    includesTitle: "Online Coaching Features Included",
    includesList: [
      "Personalized workout plan",
      "Exercise instructions & video guides",
      "Training progression system",
      "Nutrition guidance & calorie structure",
      "Weekly progress tracking",
      "Coach consultation & Q&A",
      "Continuous program adjustments"
    ],
    progression: "Weekly digital check-ins, form checks via video upload, data tracking, and routine recalibration based on your schedule."
  }
];
